import { ComponentProps } from 'react';
import { useIntl } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import SearchOrigin from '@alltrails/analytics/enums/SearchOrigin';
import { AlgoliaSearchBox } from '@alltrails/modules/AlgoliaSearch';
import '@alltrails/modules/AlgoliaSearch/index.css';
import useExperiment from 'hooks/useExperiment';

type AlgoliaSearchBoxProps = ComponentProps<typeof AlgoliaSearchBox> & {
  onLocationPage?: boolean;
};

const AlgoliaSearchBoxWrapper = (props: AlgoliaSearchBoxProps) => {
  const intl = useIntl();
  const guidesExperiment = useExperiment('web-explore-guides');

  return (
    <AlgoliaSearchBox
      {...props}
      configs={global.__AT_DATA__.algoliaConfig}
      includeGuides={guidesExperiment?.value === 'treatment'}
      navigateOnSelect
      placeholder={intl.formatMessage({ defaultMessage: 'Enter a city, park or trail name' })}
      searchOrigin={props.onLocationPage ? SearchOrigin.LocationPage : undefined}
      testId="algolia-search-box"
    />
  );
};

const AlgoliaSearchBoxErbWrapper = (props: AlgoliaSearchBoxProps) => (
  <CustomProvider>
    <AlgoliaSearchBoxWrapper {...props} />
  </CustomProvider>
);

export default AlgoliaSearchBoxErbWrapper;
